import React, {Component} from 'react';
import {Row, Col, Progress, Card, Modal, ModalBody, CardTitle, CardHeader, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, Alert} from 'reactstrap';
import { ajaxWrapperGetQuery } from '../../../utils/deviceAPI';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import moment from 'moment'
import 'react-dates/initialize';
import { DateRangePicker, isInclusivelyAfterDay, isSame } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import '../../Forms/AdvancedForms/react_dates_overrides.css';
import ReactDataGrid from 'react-data-grid';
import {CSVLink, CSVDownload} from 'react-csv';
const { Toolbar, Data: { Selectors } } = require('react-data-grid-addons');


class convertDateHuman extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                {moment(this.props.value).format('MM/DD/YY hh:mm:ss A')}
            </div>
        );
    }
}

class alarmState extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                {this.props.value ? <Alert color="danger" className="mb-0 pr-1 pt-1 pb-1 pl-3">Active</Alert> : <Alert color="white" className="mb-0 pr-1 pt-1 pb-1 pl-3">Inactive</Alert> }
            </div>
        );
    }
}

class smsNotification extends React.Component {
    constructor(props) {
        super(props);
    }
    smsStateDisplay() {
        switch (this.props.value) {
            case 1:
                return <Alert color="white" className="mb-0 pr-1 pt-1 pb-1 pl-3"><i className="fa fa-check text-success"></i> Notification Sent</Alert>;
            case 2:
                return <Alert color="danger" className="mb-0 pr-1 pt-1 pb-1 pl-3"><i className="fa fa-ban text-danger"></i> Recent Occurrence</Alert>;
            default:
                return ""
        }
    }
    render() {
        return (
            <div>
                {this.smsStateDisplay()}
            </div>
        );
    }
}



const AlarmListPender = (props) =>  {
    let items = {
        "warning" : "exclamation",
        "danger" : "times",
        "success" : "check",
        "info" : "commenting-o"
    };
    const listItems = props.items.map((alarm,index) => {
            return (
                <li key={index} className="mb-2 mt-2">
                    <i className={"fa fa-" + items[alarm.type] + " bg-" + alarm.type}></i>
                    <div className="desc">
                        <div className="title">{alarm.description}</div>
                        <div className="small text-muted text-uppercase pb-3">{alarm.name}</div>
                    </div>
                </li>
            );
        }
    );
    return (
        <div>
            {listItems}
        </div>
    );
};


class AlarmHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [
            {
                initializer: 0,
            },
            {
                initializer: 0,
            }

        ],
            bitWordData: [],
            loading: true,
            modalAlarmPointSplit: false,
            rows: [],
            filters: {},

        };
        this._columns = [
            {
                key: 'alarmDesc',
                name: 'Alarm',
                sortable: true,
                filterable: true
            },
            {
                key: 'alarmTriggerd',
                name: 'Date',
                sortable: true,
                filterable: true,
                formatter: convertDateHuman
            },
            {
                key: 'alarmState',
                name: 'State',
                sortable: true,
                formatter: alarmState
            },
            {
                key: 'smsNotifiedReason',
                name: 'Notification',
                formatter: smsNotification
            }
        ];
        this.toggleModalAlarmPointSplit = this.toggleModalAlarmPointSplit.bind(this);
        this.getCellActions = this.getCellActions.bind(this);

    }
    toggleModalAlarmPointSplit() {
        this.setState({
            modalAlarmPointSplit: !this.state.modalAlarmPointSplit
        });
    }

    getRows = () => {
        return Selectors.getRows(this.state);
    };
    rowGetter = (rowIdx) => {
        let rows = this.getRows();
        return rows[rowIdx];
    };


    componentDidMount() {
        this.setState({
            loading: false,
            rows: this.props.rows
        });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            rows: nextProps.rows
        });
    }

    getBitAlarmData = (alarmID = 0, alarmValue = 0) => {
        let query = `&id=${alarmID}&almval=${alarmValue}`;
        ajaxWrapperGetQuery('/api/deviceAlarmHistoryBitData',this.props.device,query).then((bitWordData) => {
            this.setState({
                bitWordData,
                loading: false
            });
            this.toggleModalAlarmPointSplit();

        });
    }

    getSize = () => {
        return this.getRows().length;
    };
    handleGridSort = (sortColumn, sortDirection) => {
        this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
    };

    handleFilterChange = (filter) => {
        let newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
    };

    onClearFilters = () => {
        // all filters removed
        this.setState({filters: {} });
    };

    getCellActions(column, row) {
        console.log(row);
        if (column.key === 'smsNotifiedReason' && row.unpackBits === 1 && row.alarmValue >= 1) {
            return [
                {
                    icon: 'fa fa-caret-square-o-down',
                    callback: () => {
                        this.getBitAlarmData(row.alarmID,row.alarmValue)
                    }

                }
            ];
        }
    }


    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        console.log(this.state.filters);
        return (
            <div>
            <Row className="mb-2">
                <Col xs="12">
                    <div id="alarm-history-table">
                        <ReactDataGrid onGridSort={this.handleGridSort}
                                       columns={this._columns}
                                       rowGetter={this.rowGetter}
                                       rowsCount={this.getSize()}
                                       minHeight={500}
                                       onAddFilter={this.handleFilterChange}
                                       onClearFilters={this.onClearFilters}
                                       toolbar={<Toolbar enableFilter={true}/>}
                                       getCellActions={this.getCellActions}
                                       getBitAlarmData={(row,value) => this.getBitAlarmData(row,value)}
                        />
                    </div>
                </Col>
                <Modal isOpen={this.state.modalAlarmPointSplit} toggle={this.toggleModalAlarmPointSplit} >

                    <ModalBody>
                        <Row>
                            <Col sm="10">
                                <CardTitle className="mb-1">List Alarm</CardTitle>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <hr className="mb-4"/>
                            </Col>
                        </Row>
                        <Row className="pb-2">
                            <Col sm="12">
                                <ul className="icons-list mb-5 list-inline">
                                    <AlarmListPender items={this.state.bitWordData} />
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <hr className="mb-4"/>
                            </Col>
                        </Row>
                        <Row className="pb-4">
                            <Col sm="6" className="small text-muted">
                            </Col>
                            <Col sm="6" className="small text-muted">
                                <Button color="light" className="btn btn-block" onClick={this.toggleModalAlarmPointSplit}>Close</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </Row>
            <Row className="pb-5">
                <Col xs="2" className="align-self-end">
                    <CSVLink data={this.props.rows} ><i className="fa fa-download" aria-hidden="true"></i> Download CSV</CSVLink>
                </Col>
            </Row>
            </div>
        )
    }
}

export default AlarmHistory;



// WEBPACK FOOTER //
// ./src/views/site/Alarms/AlarmHistory.js